
import React from 'react';
import { Progress } from '@/components/ui/progress';

interface LevelProgressProps {
  levelProgress: number;
  animateProgress: boolean;
}

const LevelProgress: React.FC<LevelProgressProps> = ({ levelProgress, animateProgress }) => {
  return (
    <div className="mt-6">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm text-hormony-charcoal/70">Level Progress</span>
        <span className="text-sm font-medium text-hormony-charcoal">{Math.round(levelProgress)}%</span>
      </div>
      <div>
        <Progress 
          value={levelProgress} 
          className={`h-3 bg-hormony-beige/30 ${animateProgress ? 'progress-animate' : ''}`}
        />
      </div>
    </div>
  );
};

export default LevelProgress;
